import {create} from "zustand";

interface insuranceTypeState {
  insuranceValue: number;
  disabledInsurance: boolean;
  insuranceString: string;
  setInsuranceValue: (value: number) => void;
  setDisabledInsurance: (value: boolean) => void;
  setInsuranceString: (value: string) => void;
  insuranceList: string[];
  insuranceCompValue: number[];
  setInsuranceCompValue: (value: number[]) => void;
}

const useInsuranceType = create<insuranceTypeState>((set) => ({
  insuranceValue: 0,
  disabledInsurance: false,
  insuranceString: "all insurance types",
  setInsuranceValue: (value) => set((state) => ({insuranceValue: value})),
  setDisabledInsurance: (value) => set((state) => ({disabledInsurance: value})),
  setInsuranceString: (value) => set((state) => ({insuranceString: value})),
  insuranceList: ["All", "Commercial", "Medicaid", "Medicare"],
  insuranceCompValue: [0, 1],
  setInsuranceCompValue: (value: number[]) =>
    set(() => ({insuranceCompValue: value})),
}));
export default useInsuranceType;
